import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { toast } from "sonner";

const CENTER_SAVE_PATH = /^\/(booking\/(new|edit)|hbl|mbl|rate-quote\/(new|edit)|import-rate-quote\/(new|edit)|address-book)(\/|$)/;

const isSaveNotice = (message, type, pathname) => {
  if (type !== "success") return false;
  if (!CENTER_SAVE_PATH.test(pathname || "")) return false;
  const text = String(message || "");
  if (/delet|copy|copied|print/i.test(text)) return false;
  return /\b(save|saved|update|updated|created)\b/i.test(text);
};

const ToastListener = () => {
  const { pathname } = useLocation();
  const { message, type } = useSelector((state) => state.toast);

  useEffect(() => {
    if (!message || typeof toast?.[type] !== "function") return;
    toast[type](
      message,
      isSaveNotice(message, type, pathname) ? { position: "top-center" } : undefined,
    );
  }, [message, type, pathname]);

  return null;
};

export default ToastListener;
